import React from 'react';
import TextInput from '../../../../Shared/Form/Inputs/TextInput';
import TextArea from '../../../../Shared/Form/Inputs/TextArea';
import ReCAPTCHA from 'react-google-recaptcha';
import MaskedInput from 'react-text-mask'

export default class PersonalStep extends React.Component {

    constructor() {
        super();

        this.setCaptha = this.setCaptha.bind(this);
    }

    render() {
        let displayError = Object.keys(this.props.errors).length > 0 ? this.props.errors[Object.keys(this.props.errors)[0]] : '';

        return (
            <div className="personal-step">
                <p className="b-intro">
                    To confirm your appointment, let us know how to get in touch with you:
                </p>

                <p className="validation-errors">
                    {displayError}
                </p>

                <TextInput
                    placeholder="Full Name"
                    name="name"
                    onChange={this.props.setAppointmentState}
                    isInvalid={this.props.errors['name']}
                />

                <TextInput
                    placeholder="Email"
                    name="email"
                    onChange={this.props.setAppointmentState}
                    isInvalid={this.props.errors['email']}
                />

                <MaskedInput
                    mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                    placeholder="Phone Number"
                    className={this.props.errors['phone'] != null ? "a-input invalid" : "a-input"}
                    onChange={this.props.setAppointmentState}
                    name="phone"
                    isInvalid={this.props.errors['phone']}
                    
                />

                <TextArea
                    placeholder="Enter your comments here..."
                    name="comment"
                    onChange={this.props.setAppointmentState}
                    isInvalid={this.props.errors['comment']}
                />

                <ReCAPTCHA
                    name="captcha"
                    ref={this.setCaptha}
                    className="recaptcha-widget"
                    sitekey="6LcfSkAUAAAAAA-xHDC03d2rghgPjkWMf7Mgd5eU"
                    onChange={this.onChange}
                />
            </div>
        );
    }

    // in react-google-recaptcha this field is required
    onChange(value) { }

    setCaptha(el) {
        this.props.setAppointmentState({
            target: {
                name: 'captcha',
                value: el
            }
        })
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/AppointmentForm/Steps/PersonalStep.jsx